module.exports = "<span>{{layout.index+1}}</span> <span>{{layout.name}}</span>\n"